import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_sweet_empanada.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganSE() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Sweet Empanada",
    content_category: "Vegan Menu",
    content_ids: ["vegan_sweet_empanada"],
    content_type: "vegan_vietnamese_pastries",
    value: 1.25,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Sweet Empanada | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Flaky, crispy pastry meets a lusciously smooth, lightly sweet filling. Enjoy an array of flavors including: durian, taro, mung bean, coconut."
        />
        <meta
          property="og:title"
          content="Vegan Sweet Empanada | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Flaky, crispy pastry meets a lusciously smooth, lightly sweet filling. Enjoy an array of flavors including: durian, taro, mung bean, coconut."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN SWEET EMPANADA"
          titleSubHead="$1.25 each"
          detailBody="Flaky, crispy pastry meets a lusciously smooth, lightly sweet filling. Enjoy an array of flavors including: durian, taro, mung bean, coconut."
          detailBodyBr="Contains: wheat, sesame, almond"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganSE;